import React from 'react';
import PropTypes from 'prop-types';

import {getTimeDifferenceInMinutes} from '@utils/momentWrapper';
import {convertSecondsToMinutesWithOneDecimal} from '@utils/helpers';
import {Alert} from '@ui';

export const ReportsDurationMessage = ({duration, match, minuteIncidentReports}) => {
    const {id, started_datetime, ended_datetime} = match ?? {};

    if (!duration && (!started_datetime || !ended_datetime)) {
        return id
            ? (
                <Alert icon={false} className='--marginBottom-10' severity='warning'>
                    At least one incident duration is defined in minutes but there is no information about the duration of
                    the match/event. Either define the incident duration in percent instead of minutes or make sure that the
                    information about when the match actually started and ended is available at the end of the match or set
                    a duration for the event manually.
                </Alert>
            )
            : (
                <Alert icon={false} className='--marginBottom-10' severity='warning'>
                  At least one incident duration is defined in minutes but there is no information about the duration of
                  the event. Either define the incident duration in percent instead of minutes or
                  set a duration for the event manually.
                </Alert>
            );
    } else {
        const hasIncidentLongerThanDuration = duration && minuteIncidentReports?.some(
            report =>
                report?.incident_duration &&
                parseFloat(report.incident_duration) > parseFloat(duration)
        );
        const matchDuration = started_datetime && ended_datetime
            && getTimeDifferenceInMinutes(ended_datetime, started_datetime);
        const hasIncidentLongerThanMatch = matchDuration && minuteIncidentReports?.some(
            report =>
                report?.incident_duration &&
                convertSecondsToMinutesWithOneDecimal(report.incident_duration) > parseFloat(matchDuration)
        );

        if (hasIncidentLongerThanDuration) {
            return (
                <Alert icon={false} className='--marginBottom-10' severity='warning'>
                  At least one incident duration is longer than the event duration.
                  Please correct either the incident duration or the event duration.
                </Alert>
            );
        }

        if (!duration && hasIncidentLongerThanMatch) {
            return (
                <Alert icon={false} className='--marginBottom-10' severity='warning'>
                  At least one incident duration is longer than the match duration. Please correct the incident duration
                  or set a duration for the event manually.
                </Alert>
            );
        }

        return null;
    }
};

ReportsDurationMessage.propTypes = {
    duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    match: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        started_datetime: PropTypes.string,
        ended_datetime: PropTypes.string,
    }),
    minuteIncidentReports: PropTypes.array,
};
